<template>
    <div>
        <v-text-field label="انتخاب دسته بندی مادر" :value="product_name" :hide-details="errors === undefined"
                      outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                      :disabled="disabled" @click:clear="$emit('categoryPicker', null)" :clearable="clearable"
                      ref="input"
                      :error-messages="errors"/>

        <v-dialog v-model="dialog" scrollable max-width="800px">
            <v-card elevation="2" outlined :loading="loading">
                <v-card-title>انتخاب دسته بندی</v-card-title>
                <v-divider></v-divider>

                <v-list>
                    <v-list-item @click="pick(x)" v-for="(x,i) in categories" :key="i">
                        <v-list-item-content>
                            <v-list-item-title v-text="x.name"/>
                        </v-list-item-content>

                        <v-list-item-action v-if="x.id === value">
                            <v-icon>mdi-check</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer/>

                    <v-btn color="primary" class="mr-auto" text @click="dialog = false">بستن</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "categoryPicker",

    props: ['value', 'errors', 'clearable', 'disabled'],

    model: {
        prop: 'value',
        event: 'categoryPicker'
    },

    computed: {
        product_name: function () {
            if (this.model === null) return "";
            return this.model.name;
        }
    },

    data: () => ({
        dialog: false,
        loading: false,
        search: null,
        categories: [],
        model: null,
    }),

    watch: {
        value: function () {
            this.findModel();
        }
    },

    created() {
        this.findModel();
        this.fetch();
    },

    methods: {
        fetch(page = 1) {
            this.requestApiGet('categories')
                .then(({data}) =>
                    this.categories = data.data
                ).finally(() => this.loading = false);
        },
        findModel() {
            if (this.value == null) return;

            this.loading = true;

            for (let i = 0; i < this.categories.length; i++) {
                if (this.categories[i].id === this.value) {
                    this.model = this.categories[i];
                }
            }

            this.loading = false;
        },
        pick(x) {
            this.$emit('categoryPicker', x.id);
            this.model = x;
            this.dialog = false;
        }
    }
}
</script>

<style scoped>

</style>
